/**
 * HeaderMessage
 * ======================================
 * - closes .header-message banner
 * - remembers dismissal in a cookie for N days [data-cookie-days]
 */

const EL = '.js-HeaderMessage'
const CLOSE = '.js-HeaderMessageClose'
const COOKIE_NAME = 'header_message_closed'

class HeaderMessage {
  constructor() {
    this.el = document.querySelector(EL)

    if (!this.el) {
      return false
    }

    const closeBtn = this.el.querySelector(CLOSE)

    if (closeBtn) {
      closeBtn.addEventListener('click', this.close, false)
    }
  }

  close = () => {
    const days = parseInt(this.el.getAttribute('data-cookie-days'), 10) || 1
    const date = new Date()

    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${COOKIE_NAME}=1;expires=${date.toUTCString()};path=/`

    this.el.remove()
  }
}

new HeaderMessage()
